import CryptoJS from "crypto-js";
import { SECRET_KEY_Storage, SecurityStatus } from "../Config"; // Import both

// 🔐 ENCRYPT/DECRYPT - Only if SecurityStatus = "0" (enabled)
export const setSecureItem = (key, value) => {
    
    // SecurityStatus = "0" → ENCRYPT, "1" → Plain text
    if (SecurityStatus === "0") {
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            SECRET_KEY_Storage
        ).toString();
        localStorage.setItem(key, encryptedData);
    } else {
        // Plain text storage when disabled
        localStorage.setItem(key, JSON.stringify(value));
    }
};

// 🔓 DECRYPT on GET - Only if SecurityStatus = "0" (enabled)
export const getSecureItem = (key) => {
    const storedData = localStorage.getItem(key);
    if (!storedData) return null;    
    if (SecurityStatus === "0") {
        try {
            const bytes = CryptoJS.AES.decrypt(storedData, SECRET_KEY_Storage);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            
            if (!decrypted) return null; // Empty decrypt = invalid data
            
            return JSON.parse(decrypted);
        } catch (err) {
            console.error("❌ Decryption failed for key:", key, err);
            return null;
        }
    } else {
        // Plain text parsing when disabled
        try {
            return JSON.parse(storedData);
        } catch (err) {
            console.error("❌ JSON parse failed for key:", key, err);
            return null;
        }
    }
};

// 🗑️ Remove - Works regardless of security status
export const removeSecureItem = (key) => {
    localStorage.removeItem(key);
};

// 🔍 Debug helper (optional)
export const isSecurityEnabled = () => SecurityStatus === "0";
